import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { DatePickerBase } from './DatePicker'

import { yearSelector, monthLabelSelector } from 'reduxModules/selectors/DateSelectors'
import { isPricesPageSelector } from 'reduxModules/selectors/RouterSelectors'
import { dateActions } from 'reduxModules/actions/DateActions'

const mapStateToProps = createStructuredSelector({
  year: yearSelector,
  monthLabel: monthLabelSelector,
  isPricesPage: isPricesPageSelector,
})

const mapDispatchToProps = {
  selectDate: dateActions.selectDate,
  selectRangeDate: dateActions.selectRangeDate,
}

export const DatePicker = connect(mapStateToProps, mapDispatchToProps)(DatePickerBase)



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js